import { DataCardinalityEnum } from '../../../shared/enums/data-cardinality.enum';
import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseDto } from '../../../shared/modules/base/dtos/base.dto';
import { ReportTemplateListDto } from '../../report-templates/dtos/report-template-list.dto';
import { TagListDto } from '../../tags/dtos/tag-list.dto';
import { ReportScheduleTypeEnum } from '../enums/report-schedule-type.enum';
import { ReportStatusEnum } from '../enums/report-status.enum';
import { ReportTypeEnum } from '../enums/report-type.enum';

/**
 * Report DTO for lists
 */
@CaslSubject(AppSubjectEnum.REPORT)
export class ReportListDto extends BaseDto {
	name!: string;
	status!: ReportStatusEnum;
	type!: ReportTypeEnum;
	cardinality!: DataCardinalityEnum;
	scheduleType!: ReportScheduleTypeEnum;
	scheduleAt?: Date;
	scheduleCron?: string;
	description?: string;
	isSystem!: boolean;
	template?: ReportTemplateListDto;
	tags?: TagListDto[];

	mobileTitle = (): string => {
		return `${this.name}`;
	};

	mobileSubtitle = (): string => {
		return ``;
	};
}
